import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import uuid from "react-uuid";
import { makeStyles, withStyles } from "@mui/styles";
import {
  CustomSelect,
  TextInput,
  FloatInput,
} from "components/Input/Index.js";
import CreateButton from "components/CustomButtons/CreateButton.js";
import { zone } from "variables/patrimoine.js";
import {  getObjectFromId } from "variables/lists/patrimoine.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { getSite } from "services/ConfigServices";
import { NotificationManager } from 'react-notifications';
import { materials } from "variables/lists/patrimoine.js";

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "10%",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "10%",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

function AddMaterialDialog(props) {
  const [prevData, setPrevData] = useState();
  
  const [clef, setClef] = useState("");
  const [refmaterial, setRefmaterial] = useState("");
  const [name, setName] = useState("");
  const [uncertainty, setUncertainty] = useState("");
  const [umaterial, setUmaterial] = useState("");
  const [thickness, setThickness] = useState("");
  const [thicknessprecision, setThicknessprecision] = useState("");
  const [comments, setComments] = useState("");
  const [category, setCategory] = useState("");
  const [walltype, setWalltype] = useState("");
  const [functionality, setFunctionality] = useState("");
  const [usualwall, setUsualwall] = useState("");
  const [thermicalconductivity, setThermicalconductivity] = useState("");
  const [thermicalresistance, setThermicalresistance] = useState("");
  const [thermicalcapacity, setThermicalcapacity] = useState("");
  const [volumicmass, setVolumicmass] = useState("");
  const [carbonfootprint, setCarbonfootprint] = useState("");
  const [greyenergy, setGreyenergy] = useState("");
  const [vapordiffusion, setVapordiffusion] = useState("");


  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const { closeModal, refetch, deleteCounter } = props;

  const handleClefChange = (event) => { setClef(event.target.value); };
  const handleNameChange = (event) => { setName(event.target.value); };
  const handleUncertaintyChange = (event) => { setUncertainty(event.target.value); };
  const handleUmaterialChange = (event) => {
    let uwall = event.target.value;
    let rtherm = 0;
    if (uwall > 0) {
      rtherm = Math.round((1 / uwall) * 100) / 100;
    }
    setUmaterial(uwall);
    setThermicalresistance(rtherm);
  };
  const handleThicknessChange = (event) => { setThickness(event.target.value); };
  const handleThicknessprecisionChange = (event) => { setThicknessprecision(event.target.value); };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleCategoryChange = (event) => { setCategory(event.target.value); };
  const handleWalltypeChange = (event) => { setWalltype(event.target.value); };
  const handleFunctionalityChange = (event) => { setFunctionality(event.target.value); };
  const handleUsualwallChange = (event) => { setUsualwall(event.target.value); };
  const handleThermicalconductivityChange = (event) => { setThermicalconductivity(event.target.value); };
  const handleThermicalresistanceChange = (event) => {
    let rtherm = event.target.value;
    let uwall = 0;
    if (rtherm > 0) {
      uwall = Math.round((1 / rtherm) * 100) / 100;
    }
    setThermicalresistance(rtherm);
    setUmaterial(uwall);
  };
  const handleThermicalcapacityChange = (event) => { setThermicalcapacity(event.target.value); };
  const handleVolumicmassChange = (event) => { setVolumicmass(event.target.value); };
  const handleCarbonfootprintChange = (event) => { setCarbonfootprint(event.target.value); };
  const handleGreyenergyChange = (event) => { setGreyenergy(event.target.value); };
  const handleVapordiffusionChange = (event) => { setVapordiffusion(event.target.value); };
  const handleRefmaterialChange = (event) => {
    let mater = getObjectFromId(event.target.value, materials);
    if (mater && mater.clef && mater.clef !== '')
      setClef(mater.clef);
    else
      setClef("");
    if (mater && mater.name && mater.name !== '')
      setName(mater.name);
    else
      setName("");
    if (mater && mater.category && mater.category !== '')
      setCategory(mater.category);
    else
      setCategory("");
    if (mater && mater.walltype && mater.walltype !== '')
      setWalltype(mater.walltype);
    else
      setWalltype("");
    if (mater && mater.functionality && mater.functionality !== '')
      setFunctionality(mater.functionality);
    else
      setFunctionality("");
    if (mater && mater.usualwall && mater.usualwall !== '')
      setUsualwall(mater.usualwall);
    else
      setUsualwall("");
    if (mater && mater.thickness && mater.thickness !== '')
      setThickness(mater.thickness);
    else
      setThickness("");
    if (mater && mater.thermicalconductivity && mater.thermicalconductivity !== '')
      setThermicalconductivity(mater.thermicalconductivity);
    else
      setThermicalconductivity("");
    if (mater && mater.umaterial && mater.umaterial !== '')
      setUmaterial(mater.umaterial);
    else
      setUmaterial("");
    if (mater && mater.thermicalresistance && mater.thermicalresistance !== '')
      setThermicalresistance(mater.thermicalresistance);
    else
      setThermicalresistance("");
    if (mater && mater.thermicalcapacity && mater.thermicalcapacity !== '')
      setThermicalcapacity(mater.thermicalcapacity);
    else
      setThermicalcapacity("");
    if (mater && mater.volumicmass && mater.volumicmass !== '')
      setVolumicmass(mater.volumicmass);
    else
      setVolumicmass("");
    if (mater && mater.carbonfootprint && mater.carbonfootprint !== '')
      setCarbonfootprint(mater.carbonfootprint);
    else
      setCarbonfootprint("");
    if (mater && mater.greyenergy && mater.greyenergy !== '')
      setGreyenergy(mater.greyenergy);
    else
      setGreyenergy("");
    if (mater && mater.vapordiffusion && mater.vapordiffusion !== '')
      setVapordiffusion(mater.vapordiffusion);
    else
      setVapordiffusion("");
    setRefmaterial(event.target.value);
  };


  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "structure.walls.materials"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPrevData(res.data.detail?.structure?.walls?.materials || []);
      });
  }, [deleteCounter]);

  const handleSubmit = async (event) => {
    let materialList = prevData;
    const newMaterial = {
      clef,
      refmaterial,
      name,
      uncertainty,
      umaterial,
      thickness,
      thicknessprecision,
      comments,
      category,
      walltype,
      functionality,
      usualwall,
      thermicalconductivity,
      thermicalresistance,
      thermicalcapacity,
      volumicmass,
      carbonfootprint,
      greyenergy,
      vapordiffusion,
      'uuid': uuid(),
    };
    materialList.push(newMaterial);

    axios
      .put(
        getSite(chartIdGroup, "structure.walls.materials"),
        materialList,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Matériau ajouté");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
        closeModal();
        refetch();
        deleteCounter();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <CustomSelect
                inputTitle={zone.structure.walls.materials.refmaterial}
                selectValue={refmaterial}
                handleSelectValueChange={handleRefmaterialChange}
                data={materials}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.key}
                textInput={clef}
                handleTextInputChange={handleClefChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.uncertainty}
                textInput={uncertainty}
                handleTextInputChange={handleUncertaintyChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.umaterial}
                floatInput={umaterial}
                handleFloatInputChange={handleUmaterialChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.thickness}
                floatInput={thickness}
                handleFloatInputChange={handleThicknessChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.thicknessprecision}
                floatInput={thicknessprecision}
                handleFloatInputChange={handleThicknessprecisionChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.comments}
                textInput={comments}
                handleTextInputChange={handleCommentsChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.category}
                textInput={category}
                handleTextInputChange={handleCategoryChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.walltype}
                textInput={walltype}
                handleTextInputChange={handleWalltypeChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.functionality}
                textInput={functionality}
                handleTextInputChange={handleFunctionalityChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.usualwall}
                textInput={usualwall}
                handleTextInputChange={handleUsualwallChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.thermicalconductivity}
                floatInput={thermicalconductivity}
                handleFloatInputChange={handleThermicalconductivityChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.thermicalresistance}
                floatInput={thermicalresistance}
                handleFloatInputChange={handleThermicalresistanceChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.thermicalcapacity}
                floatInput={thermicalcapacity}
                handleFloatInputChange={handleThermicalcapacityChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.volumicmass}
                floatInput={volumicmass}
                handleFloatInputChange={handleVolumicmassChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.carbonfootprint}
                floatInput={carbonfootprint}
                handleFloatInputChange={handleCarbonfootprintChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.greyenergy}
                floatInput={greyenergy}
                handleFloatInputChange={handleGreyenergyChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.vapordiffusion}
                floatInput={vapordiffusion}
                handleFloatInputChange={handleVapordiffusionChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <CreateButton buttonDisabled={false} handleSubmit={handleSubmit} />
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default AddMaterialDialog;
